// src/hooks/useMarkAllNotificationsAsRead.ts
import useNotificationStore from 'src/store/api/useNotificationStore';

export const useMarkAllNotificationsAsRead = () => {
  const { successMessage, isLoading, error, markAllNotificationsAsRead } = useNotificationStore();

  return { successMessage, isLoading, error, markAllNotificationsAsRead };
};
